var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324033 6.65167H4.49145V20H0.324033V6.65167ZM2.41224 0C2.88934 0 3.35572 0.141476 3.75241 0.406536C4.1491 0.671597 4.45829 1.04834 4.64086 1.48912C4.82344 1.9299 4.87121 2.41492 4.77813 2.88285C4.68505 3.35078 4.45531 3.78059 4.11795 4.11795C3.7806 4.45531 3.35078 4.68506 2.88285 4.77813C2.41492 4.87121 1.9299 4.82344 1.48912 4.64086C1.04834 4.45828 0.671597 4.1491 0.406536 3.75241C0.141476 3.35572 0 2.88934 0 2.41224C0 1.77248 0.254146 1.15891 0.706529 0.706529C1.15891 0.254146 1.77248 0 2.41224 0ZM7.10171 20H11.2601V13.4113C11.2601 11.6652 11.5932 9.973 13.7534 9.973C15.9136 9.973 15.9136 11.9712 15.9136 13.5194V20H20.072V12.6913C20.072 9.09091 19.2979 6.31863 15.0855 6.31863C14.2944 6.28825 13.5099 6.47314 12.8156 6.85357C12.1213 7.23401 11.5433 7.79573 11.1431 8.47885H11.0891V6.67867H7.10171V20Z",
    fill: "#7BC0EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer_linkedin.448767d220c57cf2db8a1c442c9c79f1.svg";
export { ForwardRef as ReactComponent };